import { takeLatest } from 'redux-saga/effects';

import { GET_USER_NOTIFICATIONS, PUT_FAVOURITE_USER_NOTIFICATION } from './actions';
import { fetchUserNotificationsSaga, putFavouriteUserNotificationSaga } from './saga';

export function* notificationsCentreWatchers() {
  yield takeLatest(GET_USER_NOTIFICATIONS, fetchUserNotificationsSaga);
  yield takeLatest(PUT_FAVOURITE_USER_NOTIFICATION, putFavouriteUserNotificationSaga);
}
